import ProductsBrandsRegistration from './ProductsBrandsRegistration';

export default ProductsBrandsRegistration;